export const getQueryParams = (search) => {
  const result = {};
  const params = search.substr(1);
  const queryParamArray = params.split("&");
  queryParamArray.forEach((queryParam) => {
    const item = queryParam.split("=");
    result[item[0]] = decodeURIComponent(item[1]);
  });
  return result;
};

export const getContrast = (hexcolor) => {
  // If a leading # is provided, remove it
  if (hexcolor.slice(0, 1) === "#") {
    hexcolor = hexcolor.slice(1);
  }

  // If a three-character hexcode, make six-character
  if (hexcolor.length === 3) {
    hexcolor = hexcolor
      .split("")
      .map(function (hex) {
        return hex + hex;
      })
      .join("");
  }

  // Convert to RGB value
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);

  // Get YIQ ratio
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  // Check contrast
  return yiq >= 128 ? "#000000" : "#FFFFFF";
};

export const isObject = (value) =>
  typeof value === "object" && !(value instanceof Array) && value !== null;

export const removeNullAndUndefinedValues = (object) =>
  Object.entries(object).reduce(
    (acc, [key, value]) =>
      value === null || value === undefined
        ? acc
        : {
            ...acc,
            [key]: isObject(value)
              ? removeNullAndUndefinedValues(value)
              : value,
          },
    {}
  );

export const objectToQueryString = (obj) =>
  Object.keys(obj)
    .map((key) => `${key}=${obj[key]}`)
    .join("&");


export const queryStringToObject = (queryString) => {
  if (!queryString || !queryString.includes('?')) {
    // bail if a have an empty query string
    return {};
  }

  return queryString.replace('?', '').split("&").reduce((obj, item) => {
    const query = item.split("=")
    if(query.length > 1) {
      const [key, value] = query;

      return { ...obj, [key]: value };
    } else {
      return { ...obj, [query[0]]: true };
    }
  }, {});
};

export const emptyStringValueToNull = (object) =>
  Object.entries(object).reduce(
    (acc, [key, value]) =>
      value === ""
        ? { ...acc, [key]: null }
        : {
            ...acc,
            [key]: isObject(value) ? emptyStringValueToNull(value) : value,
          },
    {}
  );

export const setScrollView = (obj) => {
  if (obj.id) {
    setTimeout(() => {
      const element = document.getElementById(obj.id);
      if (element) element.scrollIntoView();
    }, obj.scrollTime);
    setTimeout(() => {
      localStorage.removeItem(obj.localStorageKey);
    }, obj.removeTime);
  }
  if(!obj.id){
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
};

export const stringToBase64 = (str) => Buffer.from(str).toString('base64');



// WEBPACK FOOTER //
// ./src/helpers/commonHelper.js